<template>
    <div>
        <div class="mb-3">
            <label class="form-label">Titulo</label>
            <input class="form-control" type="text" :value="modelValue.title"
                @input="update('title', $event.target.value)">
        </div>
        <div class="mb-3">
            <label class="form-label">Contenido</label>
            <textarea class="form-control" rows="4" :value="modelValue.content"
                @input="update('content', $event.target.value)"></textarea>
        </div>
        <div class="row">
            <div class="col-md-6 mb-3">
                <label class="form-label">Fondo</label>
                <input class="form-control" type="text" :value="modelValue.backgroundColor"
                    @input="update('backgroundColor', $event.target.value)" placeholder="#ffffff">
            </div>
            <div class="col-md-6 mb-3">
                <label class="form-label">Borde</label>
                <input class="form-control" type="text" :value="modelValue.border"
                    @input="update('border', $event.target.value)" placeholder="1px solid #e5e7eb">
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 mb-3">
                <label class="form-label">Radio del borde</label>
                <input class="form-control" type="text" :value="modelValue.borderRadius"
                    @input="update('borderRadius', $event.target.value)" placeholder="8px">
            </div>
            <div class="col-md-6 mb-3">
                <label class="form-label">Padding</label>
                <input class="form-control" type="text" :value="modelValue.padding"
                    @input="update('padding', $event.target.value)" placeholder="16px">
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 mb-3">
                <label class="form-label">Alineacion</label>
                <select class="form-select" :value="modelValue.align" @change="update('align', $event.target.value)">
                    <option value="left">Izquierda</option>
                    <option value="center">Centro</option>
                    <option value="right">Derecha</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 mb-3">
                <label class="form-label">Color titulo</label>
                <div class="d-flex gap-2 align-items-center">
                    <input class="form-control" type="text" :value="modelValue.titleColor"
                        @input="update('titleColor', $event.target.value)">
                    <input class="form-control form-control-color" type="color"
                        :value="modelValue.titleColor || '#111827'"
                        @input="update('titleColor', $event.target.value)">
                </div>
            </div>
            <div class="col-md-6 mb-3">
                <label class="form-label">Tamano titulo</label>
                <input class="form-control" type="text" :value="modelValue.titleSize"
                    @input="update('titleSize', $event.target.value)">
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 mb-3">
                <label class="form-label">Fuente titulo</label>
                <input class="form-control" type="text" :value="modelValue.titleFamily"
                    @input="update('titleFamily', $event.target.value)">
            </div>
            <div class="col-md-6 mb-3">
                <label class="form-label">Peso titulo</label>
                <input class="form-control" type="text" :value="modelValue.titleWeight"
                    @input="update('titleWeight', $event.target.value)" placeholder="600">
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 mb-3">
                <label class="form-label">Color contenido</label>
                <div class="d-flex gap-2 align-items-center">
                    <input class="form-control" type="text" :value="modelValue.bodyColor"
                        @input="update('bodyColor', $event.target.value)">
                    <input class="form-control form-control-color" type="color"
                        :value="modelValue.bodyColor || '#111827'"
                        @input="update('bodyColor', $event.target.value)">
                </div>
            </div>
            <div class="col-md-6 mb-3">
                <label class="form-label">Tamano contenido</label>
                <input class="form-control" type="text" :value="modelValue.bodySize"
                    @input="update('bodySize', $event.target.value)">
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 mb-3">
                <label class="form-label">Fuente contenido</label>
                <input class="form-control" type="text" :value="modelValue.bodyFamily"
                    @input="update('bodyFamily', $event.target.value)">
            </div>
            <div class="col-md-6 mb-3">
                <label class="form-label">Line height</label>
                <input class="form-control" type="text" :value="modelValue.bodyLineHeight"
                    @input="update('bodyLineHeight', $event.target.value)">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MailingBlockArticleEditor',
    props: {
        modelValue: { type: Object, default: () => ({}) },
    },
    emits: ['update:modelValue'],
    methods: {
        update(key, value) {
            this.$emit('update:modelValue', { ...this.modelValue, [key]: value });
        },
    },
};
</script>
